export function partitionArray<T>(rows: T[], callback: (row: T) => boolean): T[][] {
  const matches: T[] = [];
  const nonMatches: T[] = [];

  rows.forEach((row) => (callback(row) ? matches : nonMatches).push(row));

  return [matches, nonMatches];
}
